import { render } from "./Product_detal.vue?vue&type=template&id=5e6727ea"
import script from "./Product_detal.vue?vue&type=script&lang=js"
export * from "./Product_detal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__